import Button from "components/atoms/button/Button";
import IconButton from "components/atoms/button/IconButton";
import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import Form from "components/atoms/form/Form";
import Input from "components/atoms/input/Input";
import TextArea from "components/atoms/text-area/TextArea";
import PrimaryDatePicker from "components/molecules/datepicker/PrimaryDatePicker";
import FileDropZone from "components/molecules/file-dropzone/FileDropZone";
import InputsFolder from "components/molecules/inputs-folder/InputsFolder";
import UploadedFile from "components/molecules/uploaded-file/UploadedFile";
import { format, parseISO } from "date-fns";
import { IconType } from "lib/helpers/constants/iconTypes";
import withModal from "lib/helpers/hoc/withModal";
import { useMakeDoneHrPending } from "lib/hooks/mutations/Pendings/useMakeDoneHrPending";
import { FC } from "react";
import { Control, Controller, useForm } from "react-hook-form";

import { useTranslation } from "react-i18next";

export interface IUpdateHrPendingProps<T> {
    userData?: T;
    closeModal: () => void;
}

const UpdateHrPending: FC<IUpdateHrPendingProps<any>> = ({
    userData,
    closeModal,
}) => {

    const { t } = useTranslation();

    const {
        handleSubmit,
        formState: { errors },
        control,

    } = useForm()


    const { mutateAsync: makeDoneHrPending, isLoading } = useMakeDoneHrPending()

    const uploadFile = (formData: any) => {

        const FinalFormData = new FormData();
        FinalFormData.append("file", formData.file[0]);
        FinalFormData.append("id", userData?.id);

        makeDoneHrPending(FinalFormData).then(() => {
            closeModal();
        })
    }

    return (
        <Form onSubmit={handleSubmit(uploadFile)} className="flex flex-col gap-5">
            <div className="mb-0 flex flex-col gap-7 w-full">
                <Button
                    type="button"
                    className="absolute top-[26px] left-[30px] items-center capitalize sm:top-[31px] md:top-[45px] flex gap-4 font-inter-semibold text-[#282D46] text-[22px]"
                >


                    {userData?.pending_name}
                    <p
                        className={`min-w-[120px] cursor-pointer w-[max-content]  text-[16px] !font-inter-regular flex items-center justify-center rounded-[4px] capitalize 
                  ${userData?.completed === 1
                                ? "bg-[#2DE28B] bg-opacity-[10%] text-[#2DE28B]"
                                : "bg-[#F88532] bg-opacity-[10%] text-[#F88532]"

                            }`}
                    >
                        {t(userData?.completed === 1 ? "Completed" : "Open")}
                    </p>
                </Button>
            </div>


            <InputsFolder title={t("Pending Information")}>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-[20px]">
                    <Input
                        label={t("Category")}
                        value={userData?.type}
                        readOnly
                        disabled
                    />

                    <PrimaryDatePicker
                        label={t("Creation Date")}
                        startDate={format(parseISO(userData.created_at), "yyyy-MM-dd")}
                        isDisabled={true}
                        value={format(parseISO(userData.created_at), "yyyy-MM-dd")}
                        setStartDate={() => { }}
                    />


                    <PrimaryDatePicker
                        label={t("Completed at")}
                        startDate={userData?.completed_at}
                        isDisabled={true}
                        wrapperClassName="!left-[2px]"
                        value={userData?.completed_at}
                        setStartDate={() => { }}

                    />

                    <div className="col-span-1 lg:col-span-3">
                        <TextArea
                            value={userData?.description}
                            label={t("Description")}
                            disabled
                        />
                    </div>

                    <div className="col-span-1 lg:col-span-3">
                        {userData?.file ? (
                            <UploadedFile
                                icon={userData.file.split('.')[1] === 'pdf'
                                    ? IconType.FILE_PDF_ICON
                                    : userData.file.split('.')[1] === 'csv' ||
                                        userData.file.split('.')[1] === 'xlsx' ||
                                        userData.file.split('.')[1] === 'xls'
                                        ? IconType.UPLOADED_CSV_ICON
                                        : userData.file.split('.')[1] === 'doc' || userData.file.split('.')[1] === 'docx'
                                            ? IconType.FILE_WORD_ICON
                                            : IconType.FILE_JPG_ICON
                                }
                                title={userData.file}
                                fullLink={"hr/absence/show-file/" + userData.file}
                                link={userData.file}
                                isEditable={false}
                            />
                        ) : (
                            <Controller
                                control={control}
                                name="file"
                                rules={{ required: "This field is required" }}
                                render={({ field: { onChange, value } }) => (
                                    <FileDropZone
                                        file={value}
                                        setFile={onChange}
                                        label="Proof from Doctor"
                                        formats='.jpg, .png, .pdf, .jpeg'
                                        classes={{ label: "bg-white" }}
                                        name="file"
                                        error={errors.file}
                                        control={control as Control<any>}
                                    />
                                )}
                            />
                        )}

                    </div>
                </div>
            </InputsFolder>

            <ConditionalRender condition={userData?.completed !== 1}>
                <div className="pb-8">
                    <div className="flex items-center justify-end ml-auto gap-[15px]">
                        <IconButton
                            type="submit"
                            disabled={isLoading}
                        >
                            {t("Pending Done")}
                        </IconButton>
                    </div>
                </div>
            </ConditionalRender>

        </Form>
    );
};

export default withModal(UpdateHrPending);
